import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import ProfileMenu from "./CommonForBoth/TopbarDropdown/ProfileMenu";
import { useAuthStatus } from "../hooks/useAuthStatus";
import porcherMark from "../assets/images/porcher-logo.png";
import porcherWordmark from "../assets/images/porcher-wordmark.png";

const ListingHeader = ({ onSignIn }) => {
  const { isAuthenticated, isLoading } = useAuthStatus();

  return (
    <header id="page-topbar">
      <div className="navbar-header listing-navbar-header">
        <Link to="/" className="listing-header-brand" aria-label="Porcher home">
          <img src={porcherMark} alt="" className="listing-header-mark" />
          <img src={porcherWordmark} alt="Porcher" className="listing-header-wordmark" />
        </Link>

        <div className="listing-header-actions">
          <Link to="/rentals" className="listing-header-link" data-analytics-event="nav_available_rentals_click" data-analytics-area="listing_header">Available Rentals</Link>
          <Link to="/register" className="listing-header-link" data-analytics-event="nav_register_click" data-analytics-area="listing_header">List Your Property</Link>
          {!isLoading && (
            isAuthenticated ? (
              <ProfileMenu />
            ) : (
              <button type="button" className="listing-sign-in-button" onClick={onSignIn}>
                Sign In
              </button>
            )
          )}
        </div>
      </div>
    </header>
  );
};

ListingHeader.propTypes = {
  onSignIn: PropTypes.func.isRequired,
};

export default ListingHeader;
